import { createBrowserRouter, Navigate } from "react-router-dom";
import MainLayout from "@/layouts/MainLayout";
import { HomeRouter } from "@/AppComponent";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import AdminProtectedRoute from "@/components/auth/AdminProtectedRoute";
import ProfilePage from "@/pages/ProfilePage";
import CertificatePage from "@/pages/certificates/Certificate";
import VerifyCertificatePage from "@/pages/certificates/VerifyCertificate";
import QuizHistoryPage from "@/pages/quiz/QuizHistoryPage";
import QuizResultDetailPage from "@/pages/quiz/QuizResultDetailPage";
import QuizResultsAdminPage from "@/admin/pages/QuizResultsAdminPage";
import PWAInstallPage from "@/pages/PWAInstallPage";
import CourseDetailPage from "@/pages/courses/CourseDetailPage";
import ChatAIPage from "@/pages/ChatAIPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: <HomeRouter />,
      },
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/register",
        element: <RegisterPage />,
      },
      {
        path: "/profile",
        element: (
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/install-app",
        element: <PWAInstallPage />,
      },
      {
        path: "/certificate/:id",
        element: <CertificatePage />,
      },
      {
        path: "/verify-certificate",
        element: <VerifyCertificatePage />,
      },
      {
        path: "/verify-certificate/:certificateId",
        element: <VerifyCertificatePage />,
      },
      // Route cho người dùng xem lịch sử quiz
      {
        path: "/quiz/history",
        element: (
          <ProtectedRoute>
            <QuizHistoryPage />
          </ProtectedRoute>
        ),
      },
      // Route cho người dùng xem chi tiết kết quả quiz
      {
        path: "/quiz/results/:resultId",
        element: (
          <ProtectedRoute>
            <QuizResultDetailPage />
          </ProtectedRoute>
        ),
      },
      // Route cho admin xem tất cả kết quả quiz
      {
        path: "/admin/quiz/results",
        element: (
          <AdminProtectedRoute>
            <QuizResultsAdminPage />
          </AdminProtectedRoute>
        ),
      },
      // Route cho admin xem chi tiết kết quả quiz
      {
        path: "/admin/quiz/results/:resultId",
        element: (
          <AdminProtectedRoute>
            <QuizResultDetailPage />
          </AdminProtectedRoute>
        ),
      },
      // Route cho trang chi tiết khóa học
      {
        path: "/courses/:id",
        element: <CourseDetailPage />,
      },
      // Route cho trang xem bài học trong khóa học
      {
        path: "/courses/:id/lesson/:lessonId",
        element: <CourseDetailPage />,
      },
      // Route cho trang chat AI
      {
        path: "/chat",
        element: (
          <ProtectedRoute>
            <ChatAIPage />
          </ProtectedRoute>
        ),
      },
      // Route cho trang chat AI với expert cụ thể
      {
        path: "/chat/:expertId",
        element: (
          <ProtectedRoute>
            <ChatAIPage />
          </ProtectedRoute>
        ),
      },
      // Route cho trang chat AI với cuộc trò chuyện cụ thể
      {
        path: "/chat/:expertId/:chatId",
        element: (
          <ProtectedRoute>
            <ChatAIPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "*",
        element: <Navigate to="/" replace />,
      },
    ],
  },
]);

export default router;
